import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";

const cn = classNames.bind(styles);

interface ICopyToRoom {
  rooms: { id: number | string; name: string }[];
  disabled?: boolean;
  onCopy: (toRoomId: number | string) => void;
}

const CopyToRoom: React.FC<ICopyToRoom> = ({ rooms, disabled, onCopy }) => {
  const [to, setTo] = useState<string>("");

  useEffect(() => {
    if (!rooms.some((r) => String(r.id) === to)) {
      setTo(rooms.length ? String(rooms[0].id) : "");
    }
  }, [rooms, to]);

  if (!rooms.length) return null;

  return (
    <div className={cn("copybox")}>
      <label htmlFor="standing-copy-to">Copy to another room:</label>
      <select
        id="standing-copy-to"
        value={to}
        onChange={(e) => setTo(e.target.value)}
      >
        {rooms.map((r) => (
          <option key={r.id} value={String(r.id)}>
            {r.name}
          </option>
        ))}
      </select>
      <button
        type="button"
        className={cn("btn", "btn_small")}
        disabled={disabled}
        onClick={() => {
          const room = rooms.find((r) => String(r.id) === to);
          room && onCopy(room.id);
        }}
      >
        Copy
      </button>
    </div>
  );
};

export default CopyToRoom;
